module.exports = __webpack_public_path__ + "static/media/404.10a47ef7.png";